export const bn = {
    "TRIGGER_LISTEN": "ট্রিগারগুলির জন্য শোনা হচ্ছে,",
    "ASSIST_EMPTY_MSG": "এজেন্ট এআই আপনার কথোপকথন সক্রিয়ভাবে শুনছে এবং ট্রিগার হলে স্বয়ংক্রিয়ভাবে সহায়তা করতে প্রস্তুত।",
    "MYBOT_TRIGGET_LISTEN": "বর্তমানে কোনও সক্রিয় মাই বট কাজ নেই,",
    "MYBOT_EMTPY_MSG": "মাই বটে একটি কাজ শুরু করতে, অনুসন্ধান ট্যাবে যান এবং আপনার পছন্দসই কাজের জন্য \"\"এজেন্ট ইনপুটস দিয়ে চালান\"\" বিকল্পটি নির্বাচন করুন।",
    "PROACTIVE_MODE": "প্রোঅ্যাকটিভ মোড,",
    "SETTINGS": "সেটিংস,",
    "HELP_AND_SUPPORT": "সাহায্য এবং সমর্থন,",
    "HELP": "সাহায্য,",
    "LANGUAGE": "ভাষা,",
    "THEME": "থিম,",
    "AUTOMATIC": "স্বয়ংক্রিয়,",
    "DARK": "ডার্ক,",
    "LIGHT": "লাইট,",
    "THEME_DESC": "এটি আপনার সিস্টেম ডিফল্ট মোড ব্যবহার করবে,",
    "DOCUMENTATION": "ডকুমেন্টেশন,",
    "DOC_DESC": "আমাদের গভীরতর ডকুমেন্টেশন নিবন্ধগুলি দেখুন।",
    "FAQ_U": "প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী,",
    "FAQ_DESC": "এজেন্ট এআই সম্পর্কে প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী দেখুন।",
    "KORE_ACADEMY": "কোর একাডেমি,",
    "KORE_ACA_DESC": "একাডেমি কোর্সগুলির মাধ্যমে এজেন্ট এআই সম্পর্কে আরও জানুন।",
    "SEARCH": "অনুসন্ধান,",
    "TAP_SEARCH":"অনুসন্ধানের জন্য আলতো চাপুন",
    "MY_BOT": "মাই বট,",
    "ASSIST": "সহায়তা,",
    "TRANSCRIPT": "ট্রান্সক্রিপ্ট,",
    "HISTORY": "ইতিহাস,",
    "STARTOVER": "আবার শুরু করুন,",
    "RESTART_INPUTS": "ক্যাপচার করা ইনপুটগুলি দিয়ে পুনরায় শুরু করুন,",
    "ASKCUSTOMER": "গ্রাহককে জিজ্ঞাসা করুন,",
    "TELLCUSTOMER": "গ্রাহককে বলুন,",
    "WELCOME_MSG": "স্বাগতম বার্তা,",
    "SEND": "পাঠান,",
    "SENT": "পাঠানো হয়েছে,",
    "AWAITING": "প্রতিক্রিয়ার জন্য অপেক্ষা করছি | চালিয়ে যেতে টাইপ করুন,",
    "OVERRIDE": "চালিয়ে যেতে টাইপ করুন,",
    "OVERRIDE_FILE": "চালিয়ে যেতে ফাইল সংযুক্ত করুন,",
    "ACCEPT_RESPONSE": "প্রতিক্রিয়া গ্রহণ করা হয়েছে,",
    "AGENT_ENTERED": "এজেন্ট প্রবেশ করেছে,",
    "EXPECTED_FORMAT": "প্রত্যাশিত বিন্যাস,",
    "INPUT_VALUES": "ইনপুট মান,",
    "RESTART": "পুনরায় শুরু করুন,",
    "START_OVER": "আবার শুরু করুন,",
    "RESTART_CAPTURE": "ক্যাপচার করা ইনপুটগুলি দিয়ে পুনরায় শুরু করুন,",
    "CANCEL": "বাতিল,",
    "INTERRUPT_DIALOG": "বিঘ্নিত সংলাপ কাজ,",
    "RUN": "চালান,",
    "RUN_AGENT": "এজেন্টের ইনপুট দিয়ে চালান,",
    "STEP": "পদক্ষেপ,",
    "DIALOG_TASK": "সংলাপ কাজ,",
    "FAQ": "প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী,",
    "SNIPPET": "উত্তর,",
    "ARTICLE": "ওয়েব পৃষ্ঠা,",
    "FILE": "ফাইল,",
    "SUGGESTED": "প্রস্তাবিত,",
    "ALL_DIALOG": "সমস্ত সংলাপ কাজ,",
    "DIALOG_TEXT": "সংলাপ,",
    "INTENT_IDENTIFIED": "গ্রাহকের উক্তি,",
    "NOT_WHAT_LOOKING": "ভুল প্রস্তাবনা?",
    "BOT": "বট,",
    "CUSTOMER": "গ্রাহক,",
    "YOU": "আপনি,",
    "TERMINATE_CONV": "সংলাপ কাজ শেষ করুন,",
    "TERMINATE_CONV_DESC": "আপনি কি নিশ্চিত যে আপনি সংলাপ কাজ শেষ করতে চান? এজেন্ট এআই আর প্রস্তাব করতে সক্ষম হবে না।",
    "YES_TERMINATE": "হ্যাঁ, শেষ করুন,",
    "NO_CANCEL": "না, বাতিল করুন,",
    "OVERRIDE_CONTINUE": "ওভাররাইড মোড দিয়ে চালিয়ে যান,",
    "SUMMARY_TEXT": "সারাংশ,",
    "SUBMIT": "জমা দিন,",
    "INTERRUPT_OCCURED": "বিঘ্ন ঘটেছে,",
    "IDENTIFIED_INTENT": "সনাক্ত ইচ্ছা,",
    "INTERRUPT_DESC": "এটি চালানো আপনার চলমান সংলাপ কাজ শেষ করবে।",
    "ACCEPT_RUN": "গ্রহণ করুন এবং চালান,",
    "RUN_LATER": "পরে চালান,",
    "KNOW_MORE": "আরও জানুন,",
    "MORE_TEXT": "আরও,",
    "LESS_TEXT": "কম,",
    "VIEW_MORE": "আরও দেখুন,",
    "VIEW_LESS": "কম দেখুন,",
    "SHOW_MORE_FAQ": "আরও প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী দেখান,",
    "SHOW_LESS_FAQ": "কম প্রায়শই জিজ্ঞাসিত প্রশ্নাবলী দেখান,",
    "SHOW_MORE_ARTICLE": "আরও ওয়েব পৃষ্ঠা দেখান,",
    "SHOW_LESS_ARTICLE": "কম ওয়েব পৃষ্ঠা দেখান,",
    "SHOW_MORE_SNIPPET": "আরও উত্তর দেখান,",
    "SHOW_LESS_SNIPPET": "কম উত্তর দেখান,",
    "SHOW_MORE_FILES": "আরও ফাইল দেখান,",
    "SHOW_LESS_FILES": "কম ফাইল দেখান,",
    "VIEW_ALL_DIALOG": "সমস্ত সংলাপ দেখান,",
    "VIEW_FEW_DIALOG": "কিছু সংলাপ দেখান,",
    "HELP_FULL": "উপকারী?",
    "THANKYOU": "ধন্যবাদ!",
    "EXPAND_MORE": "বিস্তৃত / আরও,",
    "CLOSE_TEXT": "বন্ধ করুন,",
    "STARTED": "শুরু হয়েছে,",
    "ENDED": "শেষ হয়েছে,",
    "VIEW_FULL_ARTICLE": "ওয়েব পৃষ্ঠা দেখুন,",
    "VIEW_FULL_FILE": "ফাইল দেখুন,",
    "COPIED": "অনুলিপি করা হয়েছে,",
    "SENTI_ANALY": "মনের বিশ্লেষণ,",
    "WRONG_SUGGESTION": "ভুল প্রস্তাবনা,",
    "INCORRECT_INTENT": "ভুল ইচ্ছা,",
    "ACCIDENTAL_CLICK": "দুর্ঘটনাক্রমে ক্লিক,",
    "TIME_TAKING": "সময় লাগে,",
    "OTHER": "অন্যান্য,",
    "PLAYBOOK_EMPTY_MSG": "প্লেবুক নির্বাচন করুন,",
    "PLAYBOOK_EMPTY_DESC": "এজেন্ট এআই প্লেবুক লোড করতে সক্ষম নয় সমস্ত উপলব্ধ প্লেবুকগুলি ডায়নামিক হওয়ার কারণে। প্লেবুকে অ্যাক্সেস করতে 'প্লেবুক নির্বাচন করুন' ক্লিক করুন,",
    "STAGE": "পর্যায়,",
    "PROCEED_TO_CLOSE": "বন্ধ করতে এগিয়ে যান,",
    "RECOMENDED_PLAYBOOK": "প্রস্তাবিত প্লেবুক,",
    "PRIMARY_SCRIPTS": "প্রাথমিক স্ক্রিপ্ট,",
    "DYNAMIC_SCRIPTS": "ডায়নামিক স্ক্রিপ্ট,",
    "RESUME": "পুনরায় শুরু করুন,",
    "ENABLE_CLOSE": "বন্ধ করতে সক্ষম করতে 'বন্ধ করতে এগিয়ে যান' বোতামে ক্লিক করুন,",
    "LIST_VIEW": "তালিকা দেখুন,",
    "TERMINATE": "শেষ করুন,",
    "MINIMIZE": "ছোট করুন,",
    "MAXIMIZE": "বড় করুন,",
    "NO_SEARCH_RESULT": "কোনও অনুসন্ধানের ফলাফল পাওয়া যায়নি,",
    "SENTIMENT_AWAITING": "মনের জন্য অপেক্ষা করছি,",
    "FILE_NAME":"ফাইলের নাম",
    "POSITIVE": "পজ,",
    "NEGATIVE": "নেগ,",
    "ASSOCIATED_WORK_NOTES": "গত সমাধান নোট,",
    "AGENT_JOINED_CONV": "এজেন্ট কথোপকথনে যোগ দিয়েছে,",
    "TAB_TEXT":"কোনও ট্যাব সক্রিয় নয়! অনুগ্রহ করে অন্তত একটি ট্যাব সক্রিয় করুন",
    "AUTOSCROLL_ASSIST": "স্বয়ংক্রিয় স্ক্রল সহায়তা ট্যাব সামগ্রী,",
    "AUTO_SCROLL_TOOLTIP":"সহায়তা ট্যাব, আমার বট এবং ট্রান্সক্রিপ্ট ট্যাব সামগ্রীর স্বয়ংক্রিয় স্ক্রোলিং নিয়ন্ত্রণ করে",
    "FILE_SIZE_MSG": "ফাইলের আকার 25MB এর মধ্যে হতে হবে। অনুগ্রহ করে আবার চেষ্টা করুন।",
    "OVERRIDE_BTN": "ওভাররাইড,",
    "CHOOSE_FILE": "ফাইল নির্বাচন করুন,",
    "SUMMARY_ERROR_TEXT": "আমরা দুঃখিত, তবে এই কথোপকথনের জন্য সারাংশ তৈরিতে একটি সমস্যা হয়েছে। দয়া করে আপনার নিজের সারাংশ তৈরি করুন।",
    "ASK_A_QUESTION": "একটি প্রশ্ন জিজ্ঞাসা করুন",
    "COPY" : "কপি",
    "PLAYBOOK": "প্লেবুক",
    "TELL_US_MORE": "আরো বলুন",
    "THANKS_FEEDBACK": "আপনার প্রতিক্রিয়ার জন্য ধন্যবাদ",
    "SOMETHING_WRONG": "কিছু ভুল হয়েছে",
    "CLICK_ERROR_DETAILS": "ভুলের বিস্তারিত দেখতে ক্লিক করুন",
    "NO_ACTIVE_PLAYBOOK": "কোনো সক্রিয় প্লেবুক নেই",
    "REPHRASE_QUESTION": "আপনি কি আপনার প্রশ্নটি পুনরায় বলতে পারেন বা অন্য কিছু জিজ্ঞাসা করতে চান?",
    "INTERNAL_INFO": "অভ্যন্তরীণ তথ্য",
    "SOURCES": "উৎস",
    "CONVERSATION_SUMMARY": "আলোচনার সংক্ষিপ্তসার",
    "WAITING": "অপেক্ষা চলছে",
    "WIDGET_DISABLED": "উইজেট নিষ্ক্রিয় করা হয়েছে",
    "AI_SETTINGS_DISABLED": "এআই সেটিংস কনফিগারেশন নিষ্ক্রিয়! অনুগ্রহ করে এআই অ্যাডমিনের সাথে যোগাযোগ করুন",
    "SERVER_CONNECTION_ERROR": "সার্ভারের সাথে সংযোগ করার সময় ত্রুটি ঘটেছে",
    "VIEW": "দেখুন",
    "ATTACHMENT_INPUT": "সংযুক্তি ইনপুট",
    "TYPE_SUMMARY": "সারাংশ লিখুন",
    "VIEW_FULL_ARTICLE_2": "সম্পূর্ণ প্রবন্ধ দেখুন",
    "VIEW_FULL_FILE_2": "সম্পূর্ণ ফাইল দেখুন",
    "BY":"দ্বারা",
    GENERATE_SUMMARY: "সারসংক্ষেপ তৈরি করুন",
    PREV_SUMMARIES: "পূর্বে তৈরি করা সারসংক্ষেপ",
    DIALOG_WORKFLOWS: "ডায়ালগ ওয়ার্কফ্লো",
    SHOW_ALL_DIALOG: "সমস্ত ডায়ালগ টাস্ক দেখান",
    SHOW_ALL_DIALOGS: "সমস্ত ডায়ালগ দেখান",
    CUSTOM_TAB: "কাস্টম ট্যাব",
    AGENT_INPUT: "এজেন্টৰ ইনপুট",
    "CUSTOM_EMPTY_MSG" : "কোনো সক্রিয় প্ৰক্রিয়া বিদ্যমান নাই",
    "CUSTOM_TAB_DESC" : "এটা প্ৰক্রিয়া আৰম্ভ কৰিবলৈ, তালিকাৰ শেষত থকা এটা প্ৰক্রিয়া চাওক।",
    "SUBMIT_OVERALL_FEEDBACK" : "সমগ্র প্রতিক্রিয়া জমা দিন",
    "FEEDBACK_POPUP_SUBTITLE" : "আপনি কি আপনার উইজেট এবং তার বিশেষ বৈশিষ্ট্যগুলি আপনার জন্য কীভাবে উপকারিতানা করেছেন?",
    "FEEDBACK_SATISFIED" : "উপকারিতানা",
    "FEEDBACK_UNSATISFIED" : "উপকারিতানা না",
    "FEEDBACK_PROVIDE_REASONS" : "আরও তথ্য দিন…",
    "FEEDBACK_TITLE" : "প্রতিক্রিয়া",
    "AGENTIC_THINKING" : "চিন্তা করছে",
    "AGENTIC_AGENT_TITLE" : "এজেন্ট",
    "AGENTIC_COPILOT_MODE_TITLE" : "এজেন্টিক কপাইলট মোড",
    "AGENTIC_SENDING_MESSAGE" : "পাঠানো হচ্ছে...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot সক্রিয়ভাবে আপনার কথোপকথন শুনছে এবং স্বয়ংক্রিয়ভাবে সহায়তা করতে প্রস্তুত",
    "AGENTIC_SEARCH_RESULTS" : "এজেন্ট ফলাফল",
    "PAUSE_AUTO_SEND" : "স্বয়ংক্রিয় পাঠানো বিরতি দিন",
    "PAUSE_AGENTIC" : "এজেন্ট বিরতি দিন",
    "RESUME_AGENTIC" : "এজেন্ট পুনরায় শুরু করুন",
    "RESUME_AUTO_SEND" : "স্বয়ংক্রিয় পাঠানো পুনরায় শুরু করুন"
}